// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Libs
import { cn } from '@/common-utils/libraries/tailwind/utils'; // adjust to your path
// Components
import TooltipHelper from '../tooltip/TooltipHelper';
import Entity from '../entity/Entity';
import Icon from '../icon/Icon';
// Common
import ICONS from '@/common-utils/enums/icons';

/**
 * @param root0
 * @param root0.text
 * @param root0.copyText
 * @param root0.className
 * @param root0.showIcon
 * @returns {JSX} CopyableChip
 */
function CopyableChip({ text, copyText, className = '', showIcon = true }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(copyText ?? text);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch {
            setCopied(false);
        }
    };

    return (
        <TooltipHelper
            asChild
            trigger={
                <button
                    onClick={handleCopy}
                    className={cn(
                        'relative inline-flex items-center justify-center cursor-pointer select-none',
                        'px-3 py-1 rounded-md border border-gray-300 shadow-sm font-semibold text-gray-800',
                        'hover:bg-gray-100 hover:border-gray-400 active:scale-[0.98]',
                        'transition-all duration-200',
                        className
                    )}
                >
                    {text}
                    {showIcon && (
                        <span className='ml-2 flex items-center'>
                            {copied ? <Icon icon={ICONS.AUTO} className='text-success' /> : <Icon icon={ICONS.CONTENT_COPY} className='opacity-70' />}
                        </span>
                    )}
                </button>
            }
            content={<Entity entity={copied ? 'title.copy.copied' : 'title.copy.click'} />}
        />
    );
}

CopyableChip.propTypes = {
    text: PropTypes.string.isRequired,
    copyText: PropTypes.string,
    className: PropTypes.string,
    showIcon: PropTypes.bool
};
export default CopyableChip;